/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["shadow-controls-drawer{padding:0 20px}@media only screen and (max-width:599.99px){shadow-controls-drawer{padding:0 5px}shadow-controls-drawer .slider-container{margin:0 5px}}"];
export { styles as styles };
